
import React from 'react';

interface PasswordStrengthMeterProps {
  strength: number;  // 0-4 where 0 is empty, 1 is weak, 2 is fair, 3 is good, 4 is strong
  feedback: string[];
}

export function PasswordStrengthMeter({ strength, feedback }: PasswordStrengthMeterProps) {
  // Get color based on strength
  const getStrengthColor = (value: number) => {
    if (value === 0) return 'bg-gray-200';
    if (value === 1) return 'bg-red-500';
    if (value === 2) return 'bg-yellow-500';
    if (value === 3) return 'bg-green-500';
    if (value === 4) return 'bg-green-600';
    return 'bg-gray-200';
  };
  
  // Get label based on strength
  const getStrengthLabel = (value: number) => {
    if (value === 0) return 'Empty';
    if (value === 1) return 'Weak';
    if (value === 2) return 'Fair';
    if (value === 3) return 'Good';
    if (value === 4) return 'Strong';
    return '';
  };
  
  return (
    <div className="space-y-2 mt-2">
      <div className="flex items-center justify-between">
        <span className="text-xs font-medium">Password strength:</span>
        <span className={`text-xs font-medium ${strength <= 1 ? 'text-red-500' : strength === 2 ? 'text-yellow-500' : 'text-green-500'}`}>
          {getStrengthLabel(strength)}
        </span>
      </div>
      
      <div className="h-1.5 w-full bg-gray-200 rounded-full overflow-hidden">
        <div 
          className={`h-full ${getStrengthColor(strength)} transition-all duration-300 ease-in-out`}
          style={{ width: strength === 0 ? '0%' : `${strength * 25}%` }}
        ></div>
      </div>
      
      {feedback.length > 0 && (
        <ul className="text-xs text-gray-600 space-y-1 mt-1">
          {feedback.map((item, index) => (
            <li key={index} className="flex items-start">
              <span className="mr-1">•</span>
              {item}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
